import { SlideInPanelAnchorLocation } from "@redotech/redo-storefront-common/slide-in-panel-anchor-location";
import * as z from "zod";

/** Shared with the design step's inputs so the caps can't drift apart. */
export const REC_INTENT_LIMITS = {
  title: 120,
  body: 400,
  buttonText: 60,
} as const;

export const RecIntentSchema = z.object({
  discountPercent: z.number().int().min(1).max(99),
  title: z.string().max(REC_INTENT_LIMITS.title),
  body: z.string().max(REC_INTENT_LIMITS.body),
  buttonText: z.string().max(REC_INTENT_LIMITS.buttonText),
  placement: z.nativeEnum(SlideInPanelAnchorLocation),
});
export type RecIntent = z.infer<typeof RecIntentSchema>;

export const DEFAULT_REC_INTENT: RecIntent = {
  discountPercent: 10,
  title: "",
  body: "",
  buttonText: "",
  placement: SlideInPanelAnchorLocation.TOP_LEFT,
};

/** Persisted as `rec-intent-launch` step data so the completion step can deep
 * link to the spotlight the merchant just created. */
export const RecIntentLaunchResultSchema = z.object({
  activated: z.boolean(),
  spotlightId: z.string().optional(),
});
export type RecIntentLaunchResult = z.infer<typeof RecIntentLaunchResultSchema>;

export const activateRecoverIntent = {
  name: "activateRecoverIntent" as const,
  input: z.object({ config: RecIntentSchema }),
  output: z.object({
    success: z.boolean(),
    /** Present when success — the enabled spotlight's Mongo `_id`. */
    spotlightId: z.string().optional(),
    errorMessage: z.string().optional(),
  }),
};
